import React from 'react'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
const ImageDisplay = ({ src, alt }) => {
    const [imageLoaded, setImageLoaded] = React.useState(false);
    const [isValidSrc, setIsValidSrc] = React.useState(!!src);
        return (<div id="attachment-display" className="smooth-image-wrapper flex-column-centered max-size">
            {isValidSrc ? 
                <TransformWrapper>
                    <TransformComponent style={{height:"100%", width:"100%"}}>
                    <img id="attachment-display-content"
                                        className={`smooth-image image-${imageLoaded ? 'visible' : 'hidden'}`}
                                        src={src} alt={alt} 
                                        onLoad={() => setImageLoaded(true)} onError={() => setIsValidSrc(false)} 
                                        style={{height:"100%",width:"100%"}}/>
                     </TransformComponent>
                </TransformWrapper>
                : <div id="attachment-display" className="smooth-no-image flex-column-centered max-size">
                    {"Your Attachment Failed to load"}
                    </div>}
            {isValidSrc && !imageLoaded && (
                <div className="smooth-preloader">
                    <span className="loader" />
                </div>
            )}
            </div>
)}

export default ImageDisplay